import format from 'date-fns/format';

export const formatDate = (inputDate: Date, dateFormat = 'dd-MM-yyyy') => format(new Date(inputDate), dateFormat);